module.exports = __webpack_public_path__ + "img/img1.7e6b339a.png";